import { AutoComplete as AntdAutoComplete } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import styled, { css } from 'styled-components';

import { colors } from '../../styles/colors/';

const StyledAutoComplete = styled(AntdAutoComplete)`
  width: ${(props) => props.width || '100%'};
  border: ${(props) =>
    props.error ? `1px solid ${colors['red']['5']}` : `1px solid ${colors['gray']['3']}`};
  border-radius: 3px;
  .ant-select-selection--single {
    height: ${(props) => (props.isMobile ? '40px !important' : '32px !important')};
    display: flex;
    font-size: ${(props) => (props.isMobile ? '16px !important' : '14px !important')};
  }

  .ant-select-selection__rendered {
    width: 100%;
  }

  &:hover {
    // If disabled, gray border
    // if error, red border
    // if no error, indigo border
    box-shadow: none;
    border-color: ${(props) =>
      props.disabled
        ? colors['gray']['3']
        : props.error
        ? colors['red']['5']
        : colors['indigo']['7']};
  }

  &:focus {
    // If disabled, no border shadow and gray border
    // if error, red border shadow and red border
    // if no error, indigo border shadow and indigo border
    box-shadow: ${(props) =>
      props.disabled
        ? 'none'
        : props.error
        ? `0px 0px 4px ${colors['red']['7']}`
        : `0px 0px 4px ${colors['indigo']['3']}`};
    border-color: ${(props) =>
      props.disabled
        ? colors['gray']['3']
        : props.error
        ? colors['red']['5']
        : colors['indigo']['7']};
  }

  &:active {
    // If disabled, no border shadow and gray border
    // if error, red border shadow and red border
    // if no error, indigo border shadow and indigo border
    box-shadow: ${(props) =>
      props.disabled
        ? 'none'
        : props.error
        ? `0px 0px 4px ${colors['red']['7']}`
        : `0px 0px 4px ${colors['indigo']['3']}`};
    border-color: ${(props) =>
      props.disabled
        ? colors['gray']['3']
        : props.error
        ? colors['red']['5']
        : colors['indigo']['7']};
  }

  &:focus-within {
    // If disabled, no border shadow and gray border
    // if error, red border shadow and red border
    // if no error, indigo border shadow and indigo border
    box-shadow: ${(props) =>
      props.disabled
        ? 'none'
        : props.error
        ? `0px 0px 4px ${colors['red']['7']}`
        : `0px 0px 4px ${colors['indigo']['3']}`};
    border-color: ${(props) =>
      props.disabled
        ? colors['gray']['3']
        : props.error
        ? colors['red']['5']
        : colors['indigo']['7']};
  }
`;

/**
 * Primary UI component for user interaction
 */
const AutoComplete = ({ dataSource, placeholder, error, disabled, isMobile, ...props }) => {
  const StyledBaseSelect = (
    <style>{css`
      .ant-select-dropdown-menu-item {
        color: ${colors['gray']['9']};
        font-size: ${isMobile ? '16px' : '14px'};
      }

      .ant-select-dropdown-menu-item:hover:not(.ant-select-dropdown-menu-item-disabled) {
        background: ${colors['background']['ocean']};
      }

      .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
        background: ${colors['aqua']['1']};
      }

      // Below are over writting of css are so that these properties can be over-written in styled components
      .ant-select-selection {
        background-color: transparent;
      }

      .ant-select-auto-complete.ant-select .ant-input {
        border: none;
        box-shadow: none;
        top: ${isMobile ? '4px' : '0px'};
      }
      .ant-select-auto-complete.ant-select .ant-select-search--inline {
        margin: 0px;
      }
      .ant-select-auto-complete.ant-select .ant-input:focus,
      .ant-select-auto-complete.ant-select .ant-input:hover {
        border: none;
        box-shadow: none;
      }
    `}</style>
  );

  return (
    <React.Fragment>
      {StyledBaseSelect}
      <StyledAutoComplete
        dataSource={dataSource}
        placeholder={placeholder}
        error={error}
        disabled={disabled}
        isMobile={isMobile}
        filterOption={(inputValue, option) =>
          option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
        }
        {...props}
      />
    </React.Fragment>
  );
};

AutoComplete.propTypes = {
  /**
   * Alert contents
   */
  dataSource: PropTypes.array,
  placeholder: PropTypes.string,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  isMobile: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

AutoComplete.defaultProps = {
  error: false,
  disabled: false,
  isMobile: false,
};

export { AutoComplete };
